<template>
    <div class="column is-one-third">
        <table class="table is-fullwidth">
            <tr>
                <th>Sub Total:</th>
                <td><input class="input" v-model="sub_total" type="number"></td>
            </tr>
            <tr>
                <th>Deposit Applied:</th>
                <td><input class="input" @keyup="calculateBalanceDue" v-model="deposit_applied" type="number"></td>
            </tr>
            <tr>
                <th>Balance Due:</th>
                <td><input class="input" v-model="balance_due" type="number"></td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        computed: {
            sub_total: {
                get() {
                    return this.$store.getters.getCustomInvoice.sub_total
                },
                set(value) {
                    this.$store.dispatch('changeCustomInvoiceFieldValue', { field: 'sub_total', value: value })
                }
            },
            deposit_applied: {
                get() {
                    return this.$store.getters.getCustomInvoice.deposit_applied
                },
                set(value) {
                    this.$store.dispatch('changeCustomInvoiceFieldValue', { field: 'deposit_applied', value: value })
                }
            },
            balance_due: {
                get() {
                    return this.$store.getters.getCustomInvoice.balance_due
                },
                set(value) {
                    this.$store.dispatch('changeCustomInvoiceFieldValue', { field: 'balance_due', value: value })
                }
            },
        },
		methods: {
            calculateBalanceDue() {
                let balanceDue = Number(this.sub_total) - Number(this.deposit_applied)
                this.$store.dispatch('changeCustomInvoiceFieldValue', { field: 'balance_due', value: balanceDue })
            }
		}
    }
</script>

<style scoped>
    th {
        font-size: small;
    }
</style>


// WEBPACK FOOTER //
// src/components/ControlPanel/Invoices/CustomInvoice/CustomInvoiceSubTotal.vue